import React, { Suspense, lazy } from "react";
import "./App.css";
import Navbar from "./Components/Navbar/Navbar";
import Hero from "./Components/Hero/Hero";
import TiendaBanner from "./Components/TiendaBanner/TiendaBanner";
import About from "./Components/About/About";
import Tienda from "./Components/Tienda/Tienda";
import Consultorio from "./Components/Consultorio/Consultorio";
import Contact from "./Components/Contact/Contact";
import Faqs from "./Components/Faqs/Faqs";
import Footer from "./Components/Footer/Footer";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ScrollToHashElement from './ScrollToHashElement';
import FloatingButton from './Components/FloatingButton/FloatingButton';

const CalendarPage = lazy(() => import("./Components/CalendarPage/CalendarPage"));
const ConfirmationPage = lazy(() => import('./Components/ConfirmationPage/ConfirmationPage'));
const PrivacyPage = lazy(() => import('./Components/PrivacyPage/PrivacyPage'));

function App() {
  return (
    <Router hashType="hashbang">
      <ScrollToHashElement />
      <div className="App" id="app">
        <Navbar />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <TiendaBanner />
              <About />
              <Tienda />
              <Consultorio />
              <Faqs />
              <Contact />
              <Footer />
            </>
          } />
          <Route path="/calendar" element={
            <Suspense fallback={null}>
              <CalendarPage />
            </Suspense>
          } />
          <Route path="/confirmation" element={
            <Suspense fallback={null}>
              <ConfirmationPage />
            </Suspense>
          } />
          <Route path="/privacidad" element={
            <Suspense fallback={null}>
              <PrivacyPage />
            </Suspense>
          } />
        </Routes>
        <FloatingButton />
      </div>
    </Router>
  );
}

export default App;
